module.exports = __webpack_public_path__ + "img/business_software.62592ba9.svg";